import { useAuth } from "@/contexts/auth";
import { useSeasonsClient } from "@/features/seasons/hooks/use-seasons-client";
import type { UpdateSeasonSettingsPayload } from "@/features/seasons/models/season";
import { useMutation } from "@tanstack/react-query";

export function useUpdateSeasonSettingsMutation() {
  const { productToken } = useAuth();
  const seasonsClient = useSeasonsClient();

  return useMutation({
    mutationFn: ({
      sport,
      organizationId,
      payload,
    }: {
      sport: string;
      organizationId: string;
      payload: UpdateSeasonSettingsPayload;
      version: number;
    }) =>
      seasonsClient.updateSeasonSettings({
        productToken: productToken as string,
        sport,
        organizationId,
        payload,
      }),
  });
}
